<div cdkScrollable class="scroller">
  <ng-content></ng-content>
</div>
<span class="back-top-button" title="Back to Top" (click)="onBackTopClick($event)"
  [ngClass]="{visible: backTopVisible}" [style.transition]="'bottom ' + backTopShowSpeed + 'ms'">
  <mat-icon>arrow_upward</mat-icon>
</span>
